var map = {
	"./arrow-24.svg": 220,
	"./avatar-24.svg": 5712,
	"./chevron-24.svg": 9094,
	"./cross-24.svg": 8885,
	"./external-link-24.svg": 7123,
	"./eye-24.svg": 1112,
	"./facebook-24.svg": 849,
	"./instagram-24.svg": 5445,
	"./linkedin-24.svg": 2519,
	"./mailto-24.svg": 1623,
	"./menu-24.svg": 4870,
	"./pinterest-24.svg": 451,
	"./plus-24.svg": 7697,
	"./success-24.svg": 5086,
	"./tiktok-24.svg": 1431,
	"./trashcan-24.svg": 7677,
	"./upload-24.svg": 9276,
	"./web-24.svg": 7195,
	"./x-24.svg": 2753,
	"./xing-24.svg": 5813,
	"./youtube-24.svg": 8780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;